import { ArrowRight, MapPin, Phone } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/site";
import { scrollToId } from "../lib/scroll";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#080d17]">
    <div className="border-t border-white/[0.06]">
      <div className="mx-auto max-w-[1240px] px-5 py-20 text-center sm:px-8 sm:py-24">
        <Reveal>
          <h2 className="text-4xl font-black uppercase tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
            READY FOR YOUR <span className="text-[#9fd3f0]">NEXT CUT?</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-[#9aa5b5] md:text-lg">
            Choose your barber and book directly with them.
          </p>
          <button
            data-testid="footer-choose-barber-button"
            onClick={() => scrollToId("barbers")}
            className="group mt-9 inline-flex items-center gap-2.5 rounded-lg bg-[#4a9bdc] px-9 py-4 text-sm font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#5aaae8]"
          >
            CHOOSE YOUR BARBER
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </div>

    <div className="border-t border-white/[0.06]">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-12 px-5 py-14 sm:px-8 md:grid-cols-3">
        <div>
          <img src="/assets/logo.png" alt="Phade Barbers logo" className="h-11 w-auto rounded-md" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/45">
            Modern cuts, clean fades and beard work — right here in Calhoun, Georgia.
          </p>
        </div>

        <div>
          <p className="text-[11px] font-bold tracking-[0.22em] text-white/40">VISIT US</p>
          <address className="mt-4 space-y-3 not-italic">
            <p className="flex items-start gap-2.5 text-sm leading-relaxed text-white/70">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#9fd3f0]" />
              {BUSINESS.addressFull}
            </p>
            <a
              data-testid="footer-phone-link"
              href={`tel:${BUSINESS.phoneTel}`}
              className="flex items-center gap-2.5 text-sm text-white/70 transition-colors hover:text-white"
            >
              <Phone className="h-4 w-4 shrink-0 text-[#9fd3f0]" />
              {BUSINESS.phoneDisplay}
            </a>
          </address>
        </div>

        <div>
          <p className="text-[11px] font-bold tracking-[0.22em] text-white/40">EXPLORE</p>
          <nav aria-label="Footer" className="mt-4 flex flex-col gap-2.5">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                data-testid={`footer-nav-link-${link.id}`}
                onClick={() => scrollToId(link.id)}
                className="w-fit text-sm text-white/70 transition-colors hover:text-[#9fd3f0]"
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="mx-auto flex max-w-[1240px] flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-white/35 sm:flex-row sm:px-8">
          <p>© {new Date().getFullYear()} Phade Barbers. All rights reserved.</p>
          <p>Calhoun, Georgia</p>
        </div>
      </div>
    </div>
  </footer>
);
